// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-points-carrousel-container {
  background-color: #f8f8f8;
  width: 100%;
}
.filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.next {
  right: 0px !important;
}
.VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.prev {
  left: -20px !important;
}
@media screen and (max-width: 280px) {
  .filter-points-carrousel-container {
    padding: 0 10px;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.prev {
    left: -10px !important;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.next {
    right: 0px !important;
  }
}
@media screen and (min-width: 281px) and (max-width: 320px) {
  .filter-points-carrousel-container {
    padding: 0 10px;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.prev {
    left: -10px !important;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.next {
    right: 0px !important;
  }
}
@media screen and (min-width: 321px) and (max-width: 768px) {
  .filter-points-carrousel-container {
    padding: 0 10px;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.prev {
    left: -10px !important;
  }
  .filter-points-carrousel-container .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.next {
    right: 0px !important;
  }
}
.box-space-filter-points {
  width: 100%;
  padding: 0 var(--spacing-extra-small);
}
.box-space-filter-points .box-filter-points {
  width: max-content;
  height: 90px;
  padding: 14px;
  min-width: 147px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #dce2f0;
  background-color: var(--color-white);
  display: flex;
  box-sizing: border-box;
  gap: 0px;
}
.box-space-filter-points .box-filter-points .box-filter-points__title {
  font-size: 11px;
  font-weight: 500;
  color: #333333;
  background-color: inherit;
  font-family: var(--font-family);
}
.box-space-filter-points .box-filter-points .box-filter-points__qtd {
  display: flex;
  font-weight: 500;
  color: #333333;
  background-color: inherit;
  font-family: var(--font-family);
}
.box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__value {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  background-color: inherit;
  font-family: var(--font-family);
}
.box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__name {
  margin-left: 4px;
  font-size: 13px;
  font-weight: 500;
  background-color: inherit;
  color: #333333;
  font-family: var(--font-family);
}
.box-space-filter-points .box-filter-points .box-filter-points__button {
  font-size: 11.5px;
  font-weight: 600;
  text-align: center;
  color: var(--color-detached);
  text-decoration: none;
  background-color: transparent;
  border: none;
  font-family: var(--font-family);
  cursor: pointer;
}
.box-space-filter-points .box-filter-points .box-filter-points__button:hover {
  filter: brightness(0.7);
}
@media screen and (max-width: 1200px) {
  .box-space-filter-points .box-filter-points {
    width: max-content;
    min-width: 117px;
    height: 90px;
    padding: 14px;
  }
}
@media (max-width: 390px) {
  .box-space-filter-points .box-filter-points {
    width: fit-content;
    min-width: 117px;
    height: 112px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__title {
    font-size: 10px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__value {
    font-size: 15px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__name {
    font-size: 11px;
  }
}
@media (max-width: 280px) {
  .box-space-filter-points .box-filter-points {
    width: fit-content;
    min-width: 117px;
    height: 112px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__title {
    font-size: 8px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__value {
    font-size: 13px;
  }
  .box-space-filter-points .box-filter-points .box-filter-points__qtd .box-filter-points__qtd__name {
    font-size: 9px;
  }
}
.VertCarousel-Container {
  width: 100vw !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/FilterPointsCarroussel/FilterPointsCarroussel.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;AACF;AAHA;EAMI,qBAAA;AAAJ;AAGA;EAEE,sBAAA;AAFF;AAKA;EACE;IACE,eAAA;EAHF;EAKA;IAGE,sBAAA;EALF;EAOA;IAGE,qBAAA;EAPF;AACF;AAUA;EACE;IACE,eAAA;EARF;EAUA;IAGE,sBAAA;EAVF;EAYA;IAGE,qBAAA;EAZF;AACF;AAeA;EACE;IACE,eAAA;EAbF;EAeA;IAGE,sBAAA;EAfF;EAiBA;IAGE,qBAAA;EAjBF;AACF;AAoBA;EACE,WAAA;EACA,qCAAA;AAlBF;AAgBA;EAKI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;AApBJ;AACA;EAsBM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,+BAAA;AApBN;AANA;EA8BM,aAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,+BAAA;AArBN;AAbA;EAqCQ,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,+BAAA;AArBR;AApBA;EA6CQ,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,+BAAA;AAtBR;AA5BA;EAuDM,iBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,4BAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;AA1BN;AA4BM;EACE,uBAAA;AA1BR;AAgCA;EACE;IAEI,kBAAA;IACA,gBAAA;IAEA,YAAA;IACA,aAAA;EAhCJ;AACF;AAoCA;EACE;IAEI,kBAAA;IACA,gBAAA;IACA,aAAA;EAnCJ;EA+BA;IAOM,eAAA;EAnCN;EA4BA;IAWQ,eAAA;EApCR;EAyBA;IAcQ,eAAA;EApCR;AACF;AA0CA;EACE;IAEI,kBAAA;IACA,gBAAA;IACA,aAAA;EAzCJ;EAqCA;IAOM,cAAA;EAzCN;EAkCA;IAWQ,eAAA;EA1CR;EA+BA;IAcQ,cAAA;EA1CR;AACF;AAgDA;EACE,uBAAA;AA9CF","sourcesContent":[".filter-points-carrousel-container {\n  background-color: #f8f8f8;\n  width: 100%;\n\n  .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.next {\n    right: -0px !important;\n  }\n}\n.VertCarousel-Container\n  .VertCarouselWithCustomNavigationArrow-navigations.prev {\n  left: -20px !important;\n}\n\n@media screen and (max-width: 280px) {\n  .filter-points-carrousel-container {\n    padding: 0 10px;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.prev {\n    left: -10px !important;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.next {\n    right: -0px !important;\n  }\n}\n\n@media screen and (min-width: 281px) and (max-width: 320px) {\n  .filter-points-carrousel-container {\n    padding: 0 10px;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.prev {\n    left: -10px !important;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.next {\n    right: -0px !important;\n  }\n}\n\n@media screen and (min-width: 321px) and (max-width: 768px) {\n  .filter-points-carrousel-container {\n    padding: 0 10px;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.prev {\n    left: -10px !important;\n  }\n  .filter-points-carrousel-container\n    .VertCarousel-Container\n    .VertCarouselWithCustomNavigationArrow-navigations.next {\n    right: -0px !important;\n  }\n}\n\n.box-space-filter-points {\n  width: 100%;\n  padding: 0 var(--spacing-extra-small);\n  .box-filter-points {\n    display: flex;\n    width: max-content;\n    height: 90px;\n    padding: 14px;\n    min-width: 147px;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 16px;\n    border: 1px solid #dce2f0;\n    background-color: var(--color-white);\n\n    display: flex;\n    box-sizing: border-box;\n    gap: 0px;\n\n    .box-filter-points__title {\n      font-size: 11px;\n      font-weight: 500;\n      color: #333333;\n      background-color: inherit;\n      font-family: var(--font-family);\n    }\n\n    .box-filter-points__qtd {\n      display: flex;\n      font-weight: 500;\n      color: #333333;\n      background-color: inherit;\n      font-family: var(--font-family);\n\n      .box-filter-points__qtd__value {\n        font-size: 17px;\n        font-weight: bold;\n        color: #333333;\n        background-color: inherit;\n        font-family: var(--font-family);\n      }\n\n      .box-filter-points__qtd__name {\n        margin-left: 4px;\n        font-size: 13px;\n        font-weight: 500;\n        background-color: inherit;\n        color: #333333;\n        font-family: var(--font-family);\n      }\n    }\n\n    .box-filter-points__button {\n      font-size: 11.5px;\n      font-weight: 600;\n\n      text-align: center;\n\n      color: var(--color-detached);\n      text-decoration: none;\n      background-color: transparent;\n      border: none;\n      font-family: var(--font-family);\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(0.7);\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .box-space-filter-points {\n    .box-filter-points {\n      width: max-content;\n      min-width: 117px;\n\n      height: 90px;\n      padding: 14px;\n    }\n  }\n}\n\n@media (max-width: 390px) {\n  .box-space-filter-points {\n    .box-filter-points {\n      width: fit-content;\n      min-width: 117px;\n      height: 112px;\n\n      .box-filter-points__title {\n        font-size: 10px;\n      }\n      .box-filter-points__qtd {\n        .box-filter-points__qtd__value {\n          font-size: 15px;\n        }\n        .box-filter-points__qtd__name {\n          font-size: 11px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 280px) {\n  .box-space-filter-points {\n    .box-filter-points {\n      width: fit-content;\n      min-width: 117px;\n      height: 112px;\n\n      .box-filter-points__title {\n        font-size: 8px;\n      }\n      .box-filter-points__qtd {\n        .box-filter-points__qtd__value {\n          font-size: 13px;\n        }\n        .box-filter-points__qtd__name {\n          font-size: 9px;\n        }\n      }\n    }\n  }\n}\n\n.VertCarousel-Container {\n  width: 100vw !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
